(function () {
  let tries = 0;
  const maxTries = 50; // ~5 Sekunden

  function initStickyCountdown() {
    const banner = document.getElementById("shopify-section-custom-countdowntime");
    if (!banner) return false;

    let spacer = document.getElementById("sticky-countdown-spacer");
    if (!spacer) {
      spacer = document.createElement("div");
      spacer.id = "sticky-countdown-spacer";
      banner.after(spacer);
    }

    function isVisible(el) {
      if (!el) return false;
      const cs = window.getComputedStyle(el);
      return cs.display !== "none" && cs.visibility !== "hidden" && el.offsetHeight > 0;
    }

    function update() {
      spacer.style.height = isVisible(banner) ? banner.offsetHeight + "px" : "0px";
      spacer.style.transition = "height 0.15s ease";

    }

    update();

    const observer = new MutationObserver(update);
    observer.observe(banner, { attributes: true, childList: true, subtree: true });
    window.addEventListener("resize", update);

    return true;
  }

  const interval = setInterval(() => {
    tries++;
    if (initStickyCountdown() || tries > maxTries) {
      clearInterval(interval);
    }
  }, 100);
})();
